import type {BrowserLike, RuntimeWithWindow} from './types';

const getRuntimeWindow = (): BrowserLike | undefined => {
  return (globalThis as RuntimeWithWindow).window;
};

export const isBrowserRuntime = (): boolean => Boolean(getRuntimeWindow());

export const getBrowserOrigin = (): string | undefined => {
  return getRuntimeWindow()?.location.origin;
};

export const getBrowserPageName = (): string | undefined => {
  const title = getRuntimeWindow()?.document.title;

  if (!title) {
    return undefined;
  }

  return encodeURI(title);
};

/** Extracts Datadog and FullStory session IDs from the browser globals, if available. */
export const getBrowserSessionMetadata = (): {
  ddSessionId?: string;
  fsSessionId?: string;
} => {
  const browserWindow = getRuntimeWindow();

  if (!browserWindow) {
    return {};
  }

  return {
    ddSessionId: browserWindow.DD_LOGS?.getInternalContext?.()?.session_id,
    fsSessionId: browserWindow.FS?.('getSession', {format: 'id'}),
  };
};
